// src/context/ProductContext.js
import React, { createContext, useState, useEffect } from "react";
import { toast } from "react-toastify";
import productsJson from "../components/jsonData";

export const ProductContext = createContext();

export const ProductProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [totalProducts, setTotalProducts] = useState(0);
  const [rentProducts, setRentProducts] = useState(0);
  const [buyProducts, setBuyProducts] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchProducts = async () => {
    setLoading(true);
    try {
      // Simulate API delay
      await new Promise((resolve) => setTimeout(resolve, 500));

      setProducts(productsJson);
      setTotalProducts(productsJson.length);
      setRentProducts(
        productsJson.filter((product) => product.prdCategory === "Rent").length
      );
      setBuyProducts(
        productsJson.filter((product) => product.prdCategory === "Buy").length
      );
    } catch (error) {
      toast.error("Failed to load product data");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  return (
    <ProductContext.Provider
      value={{
        products,
        totalProducts,
        rentProducts,
        buyProducts,
        loading,
        fetchProducts,
      }}
    >
      {children}
    </ProductContext.Provider>
  );
};
